import React from "react";
import { createPortal } from "react-dom";
import { SUPPLIER_EXPORT_HEADERS } from "./supplierExport";

export const SupplierPrintSheet = ({ rows }) => {
  if (typeof document === "undefined") return null;
  return createPortal(
    <div id="supplier-print-root" aria-hidden="true" data-testid="supplier-print-sheet">
      <table>
        <thead><tr>{SUPPLIER_EXPORT_HEADERS.map(header => <th key={header}>{header}</th>)}</tr></thead>
        <tbody>{rows.map((row, index) => (
          <tr key={index}>
            <td>{row.rowNumber}</td><td>{row.itemCode}</td><td>{row.itemName}</td><td>{row.width}</td><td>{row.height}</td><td>{row.depth}</td><td>{row.length}</td>
            <td>{row.quantity}</td><td>{row.material}</td><td>{row.finish}</td><td>{row.notes}</td>
          </tr>
        ))}</tbody>
      </table>
    </div>,
    document.body,
  );
};